import type { CSSProperties } from 'react';

/**
 * Theme CSS forces `background: … !important` on builder buttons.
 * Inline `background` cannot win — set the swatch color via a custom property.
 */
export function swatchStyle(hex: string, extra?: CSSProperties): CSSProperties {
  return {
    ...extra,
    ['--ox-swatch' as string]: hex,
  } as CSSProperties;
}
